define('responsive-gameday/views/Monitor/ViewModels/ViewModelBase',['require','exports','module','es6ish-class/es6ish-class','message-service/message-service'],function(require,exports,module) {
    var Classifier = require("es6ish-class/es6ish-class"),
        MessageService = require("message-service/message-service");


    function ViewModelBase() {
        this.gameData = { };
        this.stateUpdates = { };
        this.dataPack = { };
        this.eventType = "";
    };

    ViewModelBase.prototype = {
        refresh: function(data, datasrc, states) {
            this.gameData = data;
            this.stateUpdates = states||{};
            this.moldData(datasrc);
        },

        dispatchUpdates: function(evt, payload) {
            MessageService.publish(evt, payload);
        },

        moldData: function(flavor, states) {
            // this is where the inheritors of this class will do the meat of the work
        },

        handleUpdateRequest: function() {
            this.dispatchUpdates(this.eventType, this.dataPack);
        }
    };

    Classifier(ViewModelBase);
    return ViewModelBase;
});
